<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs
          v-model="deviceGroupId"
          :modelId="modelId"
          :serialNo="serialNo"
          @click_breadCrumbs="selectedGroupChange"
          @click_breadCrumbsDevice="selectedDeviceChange"
        />
        <v-divider />
      </v-col>
    </v-row>
    <v-row justify="center" align-content="center">
      <v-col cols="12" xl="9" lg="9" md="9" sm="6" xs="4">
        <v-card outlined class="px-16 pt-5 pb-5 compressorContents">
          <v-row dense>
            <v-col cols="12">
              <custom-icon type="machineInfo" :colors="['#162A4F']" :width="25" :height="25" class="mr-3">
              </custom-icon>
              <span
                :style="{ display: 'inline-block', height: 100 + '%', 'vertical-align': 'top' }"
                class="font-weight-bold"
              >
                {{ kikaiGouki }}
              </span>
            </v-col>
            <v-col cols="12"><v-divider></v-divider></v-col>

            <v-col cols="6" class="font-weight-bold">{{ $t('model') }}</v-col>
            <v-col cols="6" class="font-weight-bold">{{ model }}</v-col>

            <v-col cols="6" class="font-weight-bold">{{ $t('customerSMachineNo') }}</v-col>
            <v-col cols="6" class="font-weight-bold">{{ kanriGouki }}</v-col>

            <v-col cols="6" class="font-weight-bold">{{ $t('localTime') }}</v-col>
            <v-col cols="6" class="font-weight-bold">{{ lastMeasureTime }}</v-col>
            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: '20px',
                  height: '24px',
                  background: sensors[0],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('running') }}
            </v-col>

            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: 20 + 'px',
                  height: 24 + 'px',
                  background: sensors[1],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('emergency') }}
            </v-col>

            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: 20 + 'px',
                  height: 24 + 'px',
                  background: sensors[2],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('load') }}
            </v-col>
            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: 20 + 'px',
                  height: 24 + 'px',
                  background: sensors[3],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('caution') }}
            </v-col>

            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: 20 + 'px',
                  height: 24 + 'px',
                  background: sensors[4],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('local') }}
            </v-col>
            <v-col cols="6" class="font-weight-bold d-flex align-center">
              <span
                :style="{
                  display: 'inline-block',
                  width: 20 + 'px',
                  height: 24 + 'px',
                  background: sensors[5],
                }"
                class="mr-2"
              >
              </span>
              {{ $t('maintenance') }}
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(pressureSensor, index) in pressureSensors"
              :key="`pressure-${index}`"
              cols="6"
              class="font-weight-bold"
            >
              <v-row dense>
                <v-col cols="8">{{ pressureSensor.label }}</v-col>
                <v-col cols="4" md="2" align="right">{{ pressureSensor.val }}</v-col>
              </v-row>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col v-for="(tempSensor, index) in tempSensors" :key="`temp-${index}`" cols="6" class="font-weight-bold">
              <v-row dense>
                <v-col cols="8">{{ tempSensor.label }}</v-col>
                <v-col cols="4" md="2" align="right">{{ tempSensor.val }}</v-col>
              </v-row>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(currentSensor, index) in currentSensors"
              :key="`current-${index}`"
              cols="6"
              class="font-weight-bold"
            >
              <v-row dense>
                <v-col cols="8">{{ currentSensor.label }}</v-col>
                <v-col cols="4" md="2" align="right">{{ currentSensor.val }}</v-col>
              </v-row>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col v-for="(loadSensor, index) in loadSensors" :key="`load-${index}`" cols="6" class="font-weight-bold">
              <v-row dense>
                <v-col cols="8">{{ loadSensor.label }}</v-col>
                <v-col cols="4" md="2" align="right">{{ loadSensor.val }}</v-col>
              </v-row>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(error1Sensor, index) in error1SensorsComputed"
              :key="`error1-${index}`"
              cols="12"
              class="font-weight-bold"
            >
              <div v-if="error1Sensor.label !== undefined">
                <v-row dense>
                  <v-col cols="12" class="font-weight-bold d-flex align-center">
                    <span
                      :style="{
                        display: 'inline-block',
                        width: 20 + 'px',
                        height: 24 + 'px',
                        background: error1Sensor.val,
                      }"
                      class="mr-2"
                    >
                    </span>
                    {{ error1Sensor.label }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col
              v-for="(error2Sensor, index) in error2SensorsComputed"
              :key="`error2-${index}`"
              cols="12"
              class="font-weight-bold"
              align="left"
            >
              <div v-if="error2Sensor.label !== undefined">
                <v-row dense>
                  <v-col cols="12" class="font-weight-bold d-flex align-center">
                    <span
                      :style="{
                        display: 'inline-block',
                        width: 20 + 'px',
                        height: 24 + 'px',
                        background: error2Sensor.val,
                      }"
                      class="mr-2"
                    >
                    </span>
                    {{ error2Sensor.label }}
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(cautionSensor, index) in cautionSensorsComputed"
              :key="`caution-${index}`"
              cols="12"
              class="font-weight-bold"
              align="left"
            >
              <div v-if="cautionSensor.label !== undefined">
                <v-row dense>
                  <v-col cols="12" class="font-weight-bold d-flex align-center">
                    <span
                      :style="{
                        display: 'inline-block',
                        width: 20 + 'px',
                        height: 24 + 'px',
                        background: cautionSensor.val,
                      }"
                      class="mr-2"
                    >
                    </span>
                    {{ cautionSensor.label }}
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(menteSensor, index) in menteSensorsComputed"
              :key="`mente-${index}`"
              cols="12"
              class="font-weight-bold"
              align="left"
            >
              <div v-if="menteSensor.label !== undefined">
                <v-row dense>
                  <v-col cols="12" class="font-weight-bold d-flex align-center">
                    <span
                      :style="{
                        display: 'inline-block',
                        width: 20 + 'px',
                        height: 24 + 'px',
                        background: menteSensor.val,
                      }"
                      class="mr-2"
                    >
                    </span>
                    {{ menteSensor.label }}
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>
            <v-col
              v-for="(runSensor, index) in runSensorsComputed"
              :key="`run-${index}`"
              cols="12"
              class="font-weight-bold"
              align="left"
            >
              <div v-if="runSensor.label !== undefined">
                <v-row dense>
                  <v-col cols="12" class="font-weight-bold d-flex align-center">
                    <span
                      :style="{
                        display: 'inline-block',
                        width: 20 + 'px',
                        height: 24 + 'px',
                        background: runSensor.val,
                      }"
                      class="mr-2"
                    >
                    </span>
                    {{ runSensor.label }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col lg="1" md="1" sm="2" cols="3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" @click="openPage" v-if="user_info.admin" v-bind="attrs" v-on="on" depressed
              ><v-icon>mdi-email</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('alarmNotificationEmailSettings') }}</span>
        </v-tooltip>
      </v-col>
      <!-- トレンドグラフ -->
      <v-col lg="1" md="1" sm="2" cols="3">
        <router-link :to="{ name: 'TrendGraph', params: { model_id: this.modelId, serial_no: this.serialNo } }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" depressed>
                <custom-icon type="trendGraph" :size="22" :colors="['#FFFFFF', '#FFFFFF', '#FFFFFF']"> </custom-icon>
              </v-btn>
            </template>
            <span>{{ $t('sensorTrendGraph') }}</span>
          </v-tooltip>
        </router-link>
      </v-col>
      <!-- 消費電力・吐出空気量グラフ -->
      <v-col lg="1" md="1" sm="2" cols="3">
        <router-link :to="{ name: 'VolumeGraph', params: { model_id: this.modelId, serial_no: this.serialNo } }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" depressed>
                <custom-icon type="powerConsumption" :size="23" :colors="['#FFFFFF']"> </custom-icon>
              </v-btn>
            </template>
            <span>{{ $t('dischargeAirVolumePowerConsumptionGraph') }}</span>
          </v-tooltip>
        </router-link>
      </v-col>
      <!-- メンテナンス履歴 -->
      <v-col lg="1" md="1" sm="2" cols="3">
        <router-link :to="{ name: 'MaintenanceHistory', params: { model_id: this.modelId, serial_no: this.serialNo } }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" depressed>
                <custom-icon type="maintenanceHistory" :size="22" :colors="['#FFFFFF', '#162A4F']"> </custom-icon>
              </v-btn>
            </template>
            <span>{{ $t('maintenanceRecords') }}</span>
          </v-tooltip>
        </router-link>
      </v-col>
      <!-- アラーム履歴 -->
      <v-col lg="1" md="1" sm="2" cols="3">
        <router-link :to="{ name: 'AlermHistory', params: { model_id: this.modelId, serial_no: this.serialNo } }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" depressed>
                <v-icon>mdi-alert-circle</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('alarmRecords') }}</span>
          </v-tooltip>
        </router-link>
      </v-col>
      <!-- 月報 -->
      <v-col lg="1" md="1" sm="2" cols="3">
        <router-link
          v-if="deviceGroupId"
          :to="{
            name: 'MonthlyReport',
            params: { device_group_id: this.deviceGroupId, group_id: 'unset', compressors: this.compressors },
          }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" depressed>
                <v-icon>mdi-file-document-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('monthlyReport') }}</span>
          </v-tooltip>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomIcon from '../components/CustomIcon.vue';
  import machineAddressMaps from '../resources/machine_address_maps.json';
  import modelMapping from '../resources/model_mapping.json';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import { mapGetters } from 'vuex';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'CompressorInfo',
    components: {
      CustomIcon,
      BreadCrumbs,
    },
    data: () => ({
      axiosClient: null,
      deviceGroupId: null,
      modelId: null,
      serialNo: null,
      customerName: null,
      kanriGouki: null,
      kikaiGouki: null,
      model: null,
      censor: null,
      lastMeasureTime: null,
      fieldLables: [],
      fields: [],
      sensors: [],
      pressureSensors: [],
      tempSensors: [],
      currentSensors: [],
      loadSensors: [],
      error1Sensors: [],
      error2Sensors: [],
      cautionSensors: [],
      runSensors: [],
      menteSensors: [],
      pressureSensorsSub: [],
      tempSensorsSub: [],
      currentSensorsSub: [],
      loadSensorsSub: [],
      error1SensorsSub: [],
      error2SensorsSub: [],
      cautionSensorsSub: [],
      runSensorsSub: [],
      menteSensorsSub: [],
      localeId: 2,
      compressors: [],
    }),
    computed: {
      ...mapGetters('auth', ['user_info']),
      error1SensorsComputed() {
        return this.error1Sensors.filter((item) => {
          return item.label !== undefined && item.label !== '-';
        });
      },
      error2SensorsComputed() {
        return this.error2Sensors.filter((item) => {
          return item.label !== undefined && item.label !== '-';
        });
      },
      cautionSensorsComputed() {
        return this.cautionSensors.filter((item) => {
          return item.label !== undefined && item.label !== '-';
        });
      },
      menteSensorsComputed() {
        return this.menteSensors.filter((item) => {
          return item.label !== undefined && item.label !== '-';
        });
      },
      runSensorsComputed() {
        return this.runSensors.filter((item) => {
          return item.label !== undefined && item.label !== '-';
        });
      },
    },
    async created() {
      // URLから値を取得
      this.$store.commit('loading/start_loading');
      this.getComperessorInfo();
      this.$store.commit('loading/end_loading');
    },
    mounted() {
      this.setCompressorTimeout();
    },
    beforeDestroy() {
      this.clearCompressorTimeout(); // Vue 2 の場合
    },
    methods: {
      censorColor() {
        return 'red';
      },
      // パンくずリストクリック
      selectedGroupChange(group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
      selectedDeviceChange(device) {
        if (this.$route.name !== 'CompressorInfo') {
          this.$router.push({
            name: 'CompressorInfo',
            params: { model_id: device.model_id, serial_no: device.serial_no },
          });
        }
      },
      localTime(date, timezone) {
        if (date === undefined) {
          return '';
        }
        // タイムゾーンが設定されていない場合はブラウザのタイムゾーンを使用する
        if (timezone === undefined || timezone === null) {
          const offset = this.$moment().utcOffset();
          return this.$moment.utc(date).utcOffset(offset).format('YYYY/MM/DD HH:mm:ss');
        }

        // UTC時刻とタイムゾーンから現地時間を返却
        return this.$moment.utc(date).utcOffset(timezone).format('YYYY/MM/DD HH:mm:ss');
      },
      async setLocale() {
        switch (this.$i18n.locale) {
          case 'en':
            this.localeId = 1;
            break;
          case 'ja':
            this.localeId = 2;
            break;
          case 'zh':
            this.localeId = 3;
            break;
        }
      },
      async openPage() {
        this.$store.commit('loading/start_loading');
        const machine = await this.apiRequest('/v1/master-info/devices', 'GET', {
          model_id: this.$route.params.model_id,
          serial_no: this.$route.params.serial_no,
        });
        try {
          this.$router.push({
            name: 'AlermMailSetting',
            params: {
              device_group_id: this.user_info.deviceGroupId,
              model_id: machine[0].model_id,
              serial_no: machine[0].serial_no,
            },
          });
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async getComperessorInfo() {
        this.modelId = this.$route.params.model_id;
        this.serialNo = this.$route.params.serial_no;
        // ロケールを変更
        await this.setLocale();

        //機器情報・お客様管理号機を設定
        const deviceData = await this.apiRequest('/v1/master-info/devices', 'GET', {
          model_id: this.modelId,
          serial_no: this.serialNo,
        });
        if (deviceData === null) {
          this.$store.commit('loading/end_loading');
          return;
        }
        console.log(deviceData);

        const compressor = {
          modelId: this.modelId,
          serialNo: this.serialNo,
        };
        this.compressors.push(compressor);

        // グループIDを設定
        const userDevice = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
          model_id: this.modelId,
          serial_no: this.serialNo,
        });
        const result = userDevice[0];
        if (result !== null) {
          this.deviceGroupId = result.device_group_id;
        }

        //最新のセンサーデータを取得
        const latestSensorData = await this.apiRequest('/v1/sensor-data-file-mgt/getLatestSensorData', 'POST', {
          sensor_list: [
            {
              model_id: this.modelId,
              serial_no: this.serialNo,
            },
          ],
        });
        if (latestSensorData === null) {
          this.$store.commit('loading/end_loading');
          return;
        }
        console.log(latestSensorData);

        this.modelId = latestSensorData[0].modelId;
        this.kikaiGouki = latestSensorData[0].serialNo.substring(0, latestSensorData[0].serialNo.indexOf('_'));
        (this.model = deviceData[0].optional_info_1), // 型式
          (this.kanriGouki = deviceData[0].optional_info_2); // お客様管理号機

        let measureTime = null;
        if (latestSensorData[0].lastMeasureTime !== undefined) {
          measureTime = this.localTime(
            `${latestSensorData[0].lastMeasureTime.substring(0, 4)}-${latestSensorData[0].lastMeasureTime.substring(
              4,
              6
            )}-${latestSensorData[0].lastMeasureTime.substring(6, 8)} ${latestSensorData[0].lastMeasureTime.substring(
              8,
              10
            )}:${latestSensorData[0].lastMeasureTime.substring(10, 12)}:${latestSensorData[0].lastMeasureTime.substring(
              12,
              14
            )}.${latestSensorData[0].lastMeasureTime.substring(14)}`,
            deviceData[0].time_zone
          );
          console.log(measureTime);
          this.lastMeasureTime = measureTime;
        } else {
          this.lastMeasureTime = 'Invalid date';
        }

        const list = latestSensorData[0].timeList.filter(
          (list) => list.dataList.length > 0 && list.sensorId.indexOf('sn_') >= 0
        );

        // デバイスデータを取得
        const machineDevices = machineAddressMaps.filter(
          (machineAddress) => machineAddress.model_id === this.modelId
        )[0].device;
        if (machineDevices.length === 0) {
          this.$store.commit('snackbar/show_snackbar', {
            text: '存在しないデバイスです。',
            color: 'error',
            timeout: 5000,
            multiline: false,
          });
          this.$store.commit('loading/end_loading');
          return;
        }
        machineDevices.forEach((el) => {
          // 圧力に関するセンサー値をセット
          if (
            el.address == '0001' ||
            el.address == '0002' ||
            el.address == '0003' ||
            el.address == '0004' ||
            el.address == '0005'
          ) {
            this.pressureSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
          // 温度に関するセンサー値をセット
          if (
            el.address == '0006' ||
            el.address == '0007' ||
            el.address == '0008' ||
            el.address == '0009' ||
            el.address == '0010' ||
            el.address == '0011' ||
            el.address == '0030' ||
            el.address == '0031' ||
            el.address == '0032' ||
            el.address == '0033'
          ) {
            this.tempSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
          // 電流に関するセンサー値をセット
          if (el.address == '0012') {
            this.currentSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
          if (el.address == '0013') {
            if (latestSensorData[0].modelId === 'OIL_FREE') {
              this.tempSensorsSub.push({
                address: el.address.slice(-3),
                label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
                val: '',
              });
            } else {
              this.currentSensorsSub.push({
                address: el.address.slice(-3),
                label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
                val: '',
              });
            }
          }
          // 負荷に関するセンサー値をセット
          if (el.address == '0014') {
            this.loadSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
          if (
            el.address == '0015' &&
            (latestSensorData[0].modelId === 'OIL_INJECTION' || latestSensorData[0].modelId === 'OIL_INJECTION2')
          ) {
            this.loadSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          } else if (el.address == '0015' && latestSensorData[0].modelId === 'OIL_FREE') {
            this.tempSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }

          // 運転に関するセンサー値をセット
          if (el.address == '0020') {
            this.loadSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
          if (
            el.address == '0022' &&
            latestSensorData[0].modelId !== 'OIL_INJECTION3' &&
            latestSensorData[0].modelId !== 'OIL_INJECTION4'
          ) {
            this.loadSensorsSub.push({
              address: el.address.slice(-3),
              label: this.localeId === 1 ? el.name_locale1 : this.localeId === 2 ? el.name_locale2 : el.name_locale3,
              val: '',
            });
          }
        });

        // センサーデータを取得
        const machineSensors = machineAddressMaps.filter(
          (machineAddress) => machineAddress.model_id === this.modelId
        )[0].sensors;
        if (machineSensors.length === 0) {
          this.$store.commit('snackbar/show_snackbar', {
            text: '存在しないセンサーです。',
            color: 'error',
            timeout: 5000,
            multiline: false,
          });
          this.$store.commit('loading/end_loading');
          return;
        }

        this.sensors[0] = '#9E9E9E'; // 運転
        this.sensors[1] = '#9E9E9E'; // 異常
        this.sensors[2] = '#9E9E9E'; // 負荷
        this.sensors[3] = '#9E9E9E'; // 警報
        this.sensors[4] = '#9E9E9E'; // 機側
        this.sensors[5] = '#9E9E9E'; // メンテナンス

        machineSensors.forEach((el) => {
          // 異常値1に関するセンサー値をセット
          if (el.address == '0024') {
            el.data.forEach((el2) => {
              this.error1SensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
          // 異常値2に関するセンサー値をセット
          if (el.address == '0025') {
            el.data.forEach((el2) => {
              this.error2SensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
          // 警告に関するセンサー値をセット
          if (el.address == '0026') {
            el.data.forEach((el2) => {
              this.cautionSensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
          // 運転ランプに関するセンサー値をセット
          if (el.address == '0027') {
            el.data.forEach((el2) => {
              this.runSensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
          // メンテナンスに関するセンサー値をセット
          if (el.address == '0028') {
            el.data.forEach((el2) => {
              this.menteSensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
          if (el.address == '0029') {
            el.data.forEach((el2) => {
              this.menteSensorsSub.push({
                address: el.address.slice(-3),
                label:
                  this.localeId === 1 ? el2.name_locale1 : this.localeId === 2 ? el2.name_locale2 : el2.name_locale3,
                val: '#9E9E9E',
              });
            });
          }
        });

        let errors1 = [];
        let errors2 = [];
        let cautions = [];
        let runs = [];
        let mentes = [];
        console.log(list);
        list.forEach((el) => {
          let censorValue = '';

          if (el.sensorId === 'sn_D001' || el.sensorId === 'sa_D001') {
            censorValue = `${
              this.localeId === 1
                ? (Math.floor(el.dataList[0].data * 1000) / 100).toFixed(3) + 'mbar'
                : (Math.floor(el.dataList[0].data * 100) / 100).toFixed(2) + 'kPa'
            }`;
          } else if (
            el.sensorId === 'sn_D002' ||
            el.sensorId === 'sa_D002' ||
            el.sensorId === 'sn_D003' ||
            el.sensorId === 'sa_D003' ||
            el.sensorId === 'sn_D004' ||
            el.sensorId === 'sa_D004' ||
            el.sensorId === 'sn_D005' ||
            el.sensorId === 'sa_D005'
          ) {
            if (el.sensorId === 'sn_D004' && latestSensorData[0].modelId === 'WATER_INJECTION') {
              censorValue = `${
                this.localeId === 1
                  ? (Math.floor(el.dataList[0].data * 1000) / 100).toFixed(3) + 'bar'
                  : (Math.floor(el.dataList[0].data * 100) / 100).toFixed(2) + 'kPa'
              }`;
            } else {
              censorValue = `${
                this.localeId === 1
                  ? (Math.floor(el.dataList[0].data * 1000) / 100).toFixed(3) + 'bar'
                  : (Math.floor(el.dataList[0].data * 100) / 100).toFixed(2) + 'MPa'
              }`;
            }
          } else if (
            el.sensorId === 'sn_D006' ||
            el.sensorId === 'sa_D006' ||
            el.sensorId === 'sn_D007' ||
            el.sensorId === 'sa_D007' ||
            el.sensorId === 'sn_D008' ||
            el.sensorId === 'sa_D008' ||
            el.sensorId === 'sn_D009' ||
            el.sensorId === 'sa_D009' ||
            el.sensorId === 'sn_D010' ||
            el.sensorId === 'sa_D010' ||
            el.sensorId === 'sn_D011' ||
            el.sensorId === 'sa_D011'
          ) {
            censorValue = `${el.dataList[0].data} ℃`;
          } else if (el.sensorId === 'sn_D012' || el.sensorId === 'sa_D012') {
            censorValue = `${Math.floor(el.dataList[0].data)} A`;
          } else if (el.sensorId === 'sn_D013' || el.sensorId === 'sa_D013') {
            if (latestSensorData[0].modelId === 'OIL_FREE') {
              censorValue = `${el.dataList[0].data} ℃`;
            } else {
              censorValue = `${el.dataList[0].data} A`;
            }
          } else if (el.sensorId === 'sn_D014' || el.sensorId === 'sa_D014') {
            censorValue = `${el.dataList[0].data} %`;
          } else if (el.sensorId === 'sn_D015' || el.sensorId === 'sa_D015') {
            if (latestSensorData[0].modelId === 'OIL_FREE') {
              censorValue = `${el.dataList[0].data} ℃`;
            } else {
              censorValue = `${el.dataList[0].data} %`;
            }
          } else if (el.sensorId === 'sn_D016' || el.sensorId === 'sa_D016') {
            censorValue = `${el.dataList[0].data}`;
          } else if (el.sensorId === 'sn_D017' || el.sensorId === 'sa_D017') {
            censorValue = `${el.dataList[0].data}`;
          } else if (el.sensorId === 'sn_D018' || el.sensorId === 'sa_D018') {
            censorValue = `${el.dataList[0].data}`;
          } else if (el.sensorId === 'sn_D019' || el.sensorId === 'sa_D019') {
            censorValue = `${el.dataList[0].data}`;
          } else if (el.sensorId === 'sn_D020_021' || el.sensorId === 'sa_D020_021') {
            let formatter = new Intl.NumberFormat('ja-JP');
            censorValue = `${formatter.format(el.dataList[0].data)} hr`;
          } else if (el.sensorId === 'sn_D022_023' || el.sensorId === 'sa_D022_023') {
            let formatter = new Intl.NumberFormat('ja-JP');
            censorValue = `${formatter.format(el.dataList[0].data)} ${this.localeId === 1 ? 'times' : '回'}`;
          } else if (el.sensorId === 'sn_D024' || el.sensorId === 'sa_D024') {
            errors1 = Number(el.dataList[0].data).toString(2).padStart(16, '0').split('').reverse();
          } else if (el.sensorId === 'sn_D025' || el.sensorId === 'sa_D025') {
            errors2 = Number(el.dataList[0].data).toString(2).padStart(16, '0').split('').reverse();
          } else if (el.sensorId === 'sn_D026' || el.sensorId === 'sa_D026') {
            cautions = Number(el.dataList[0].data).toString(2).padStart(16, '0').split('').reverse();
          } else if (el.sensorId === 'sn_D027' || el.sensorId === 'sa_D027') {
            censorValue = el.dataList[0].data;

            if (el.dataList[0].data.length > 0) {
              // 10進数を2進数に変換し、1桁ずつ配列に分け配列を逆順にする
              const lampDatas = Number(censorValue).toString(2).match(/.{1}/g).reverse();

              this.sensors[0] = lampDatas[modelMapping[this.modelId].start] == '1' ? '#8BC34A' : '#9E9E9E'; // 運転
              this.sensors[1] = lampDatas[modelMapping[this.modelId].emergency] == '1' ? '#EF5350' : '#9E9E9E'; // 異常
              this.sensors[2] = lampDatas[modelMapping[this.modelId].load] == '1' ? '#8BC34A' : '#9E9E9E'; // 負荷
              this.sensors[3] = lampDatas[modelMapping[this.modelId].caution] == '1' ? '#FF9800' : '#9E9E9E'; // 警報
              this.sensors[4] = lampDatas[modelMapping[this.modelId].local] == '1' ? '#8BC34A' : '#9E9E9E'; // 機側
              this.sensors[5] = lampDatas[modelMapping[this.modelId].maintenance] == '1' ? '#FDD835' : '#9E9E9E'; // メンテナンス
            } else {
              this.sensors[0] = '#9E9E9E'; // 運転
              this.sensors[1] = '#9E9E9E'; // 異常
              this.sensors[2] = '#9E9E9E'; // 負荷
              this.sensors[3] = '#9E9E9E'; // 警報
              this.sensors[4] = '#9E9E9E'; // 機側
              this.sensors[5] = '#9E9E9E'; // メンテナンス
            }

            runs = Number(el.dataList[0].data).toString(2).padStart(16, '0').split('').reverse();
          } else if (el.sensorId === 'sn_D028' || el.sensorId === 'sa_D028') {
            mentes = Number(el.dataList[0].data).toString(2).padStart(16, '0').split('').reverse();
          } else if (
            el.sensorId === 'sn_D030' ||
            el.sensorId === 'sa_D030' ||
            el.sensorId === 'sn_D031' ||
            el.sensorId === 'sa_D031' ||
            el.sensorId === 'sn_D032' ||
            el.sensorId === 'sa_D032' ||
            el.sensorId === 'sn_D033' ||
            el.sensorId === 'sa_D033'
          ) {
            censorValue = `${el.dataList[0].data} ℃`;
          }

          this.pressureSensors = this.pressureSensorsSub;
          this.tempSensors = this.tempSensorsSub;
          this.currentSensors = this.currentSensorsSub;
          this.loadSensors = this.loadSensorsSub;
          this.error1Sensors = this.error1SensorsSub;
          this.error2Sensors = this.error2SensorsSub;
          this.cautionSensors = this.cautionSensorsSub;
          this.runSensors = this.runSensorsSub;
          this.menteSensors = this.menteSensorsSub;
          // 圧力のセンサー値をセット
          this.pressureSensors.forEach((el2) => {
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = censorValue;
            }
          });
          // 温度のセンサー値をセット
          this.tempSensors.forEach((el2) => {
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = censorValue;
            }
          });
          // 電流のセンサー値をセット
          this.currentSensors.forEach((el2) => {
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = censorValue;
            }
          });
          // 負荷のセンサー値をセット
          this.loadSensors.forEach((el2) => {
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = censorValue;
            }
          });

          // 異常1のセンサー値をセット
          for (let i = 0, len = this.error1Sensors.length; i < len; i++) {
            const el2 = this.error1Sensors[i];
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = errors1[i] == '1' ? '#EF5350' : '#9E9E9E';
            }
          }
          // 異常2のセンサー値をセット
          for (let i = 0, len = this.error2Sensors.length; i < len; i++) {
            const el2 = this.error2Sensors[i];
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = errors2[i] == '1' ? '#EF5350' : '#9E9E9E';
            }
          }
          // 警告のセンサー値をセット
          for (let i = 0, len = this.cautionSensors.length; i < len; i++) {
            const el2 = this.cautionSensors[i];
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = cautions[i] == '1' ? '#FF9800' : '#9E9E9E';
            }
          }
          // 運転ランプのセンサー値をセット
          for (let i = 0, len = this.runSensors.length; i < len; i++) {
            const el2 = this.runSensors[i];
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = runs[i] == '1' ? '#8BC34A' : '#9E9E9E';
            }
          }
          // メンテナンスのセンサー値をセット
          for (let i = 0, len = this.menteSensors.length; i < len; i++) {
            const el2 = this.menteSensors[i];
            if (el.sensorId.indexOf(el2.address) >= 0) {
              el2.val = mentes[i] == '1' ? '#FDD835' : '#9E9E9E';
            }
          }
        });
        this.pressureSensorsSub = [];
        this.tempSensorsSub = [];
        this.currentSensorsSub = [];
        this.loadSensorsSub = [];
        this.error1SensorsSub = [];
        this.error2SensorsSub = [];
        this.cautionSensorsSub = [];
        this.runSensorsSub = [];
        this.menteSensorsSub = [];
        this.setCompressorTimeout();
      },
      setCompressorTimeout() {
        // 前のタイマーがあればリセット（キャンセル）する
        if (this.timeoutObj) {
          clearTimeout(this.timeoutObj);
        }
        // 新しくセット
        this.timeoutObj = setTimeout(this.getComperessorInfo, 60000);
      },
      clearCompressorTimeout() {
        if (this.timeoutObj) {
          clearTimeout(this.timeoutObj);
          this.timeoutObj = null;
        }
      },
    },
  };
</script>
<style scoped>
  .censor {
    margin: 5px;
    border-radius: 3px;
  }
  .compressorContents {
    height: 65vh;
    overflow-y: scroll;
  }
</style>
